// frontend/src/context/DarkModeContext.js
import { createContext, useContext } from "react";
import { useDarkMode } from "../hooks/useDarkMode";

const DarkModeContext = createContext(null);

export function DarkModeProvider({ children }) {
  const darkMode = useDarkMode();
  return <DarkModeContext.Provider value={darkMode}>{children}</DarkModeContext.Provider>;
}

export function useDarkModeContext() {
  return useContext(DarkModeContext);
}
